import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Form, FormGroup, Label, Input, ButtonGroup, FormText, Button,
} from 'reactstrap';
import * as _ from 'lodash';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import InputError from '../elments/InputError';
import {
  LOGO_LARGE_BLACK, handleGraphqlError, staticConstants, NUMERIC_VALUE,
} from '../../../utils';
import { FORGOT_PASSWORD, LOADER_MUTATION } from '../../../graphql-client/mutations';


function ForgotPasswordForm() {
  const { errors, handleSubmit, register } = useForm({
    mode: 'onblur',
  });
  const [apiData, setApiData] = useState();
  const { addToast } = useToasts();
  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });
  const [forgotPassword] = useMutation(FORGOT_PASSWORD, {
    variables: apiData,

    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data.forgetPassword.message, { appearance: 'success' });
    },
  });

  const onSubmit = (data) => {
    setApiData(_.pick(data, ['email']));
    loader({ variables: { show: true } });
    forgotPassword(_.pick(data, ['email']));
  };

  return (
    <>
      <div className="forgot-password-wrapper">
        <div className="form-container">
          <div className="forgot-password-logo">
            <img src={LOGO_LARGE_BLACK} alt="BYGmusic" />
          </div>
          <span className="icon icon-lock" />
          <h2>Forgot Password?</h2>
          <p>
            Enter the email address you’ve used while signing up and we will send you a link to reset your password.
          </p>
          <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <FormGroup className={errors.email ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Label
                for="Email"
              >
                Email address
              </Label>
              <Input
                type="email"
                name="email"
                placeholder="Enter email address"
                innerRef={register({
                  required: true,
                  type: 'email',
                  maxLength: NUMERIC_VALUE.TWO_HUNDRED,
                  minLength: NUMERIC_VALUE.THREE,
                })}
              />
              <InputError error={errors.email} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
            </FormGroup>
            <ButtonGroup className="justify-content-center">
              <Button
                color="primary"
                element="inlineBlock"
                type="submit"
                className="btn-md"
              >
                Send link
              </Button>
            </ButtonGroup>
            <FormText
              color="black"
              className="form-text-login"
            >
              <Link to="/login">Sign in</Link>
            </FormText>
          </Form>
        </div>
      </div>
    </>
  );
}

export default ForgotPasswordForm;
